import { Component, Input, OnInit } from "@angular/core";
import { CommonModule, NgClass } from "@angular/common";

import { SkeletonModule } from "primeng/skeleton";

import { MonthCardData, StatusBadgeConfig } from "@shared/models";
import { getContractualMonth } from "@shared/functions/date.functions";
import { StatusBadgeComponent } from "@shared/components";
import { HiRecordModalComponent } from "../hi-record-modal/hi-record-modal.component";
import { MonthInfoModalComponent } from "../month-info-modal/month-info-modal.component";
import { MinutesToTimePipe } from "@shared/pipes";

@Component({
  selector: "app-month-card",
  standalone: true,
  imports: [
    SkeletonModule,
    StatusBadgeComponent,
    CommonModule,
    NgClass,
    HiRecordModalComponent,
    MonthInfoModalComponent,
    MinutesToTimePipe,
  ],
  templateUrl: "./month-card.component.html",
  styleUrl: "./month-card.component.scss",
})
export class MonthCardComponent implements OnInit {
  @Input() month: "current" | "next" = "current";
  @Input() cardData: MonthCardData = {} as MonthCardData;
  fosModalShown: boolean = false;
  monthInfoModalShown: boolean = false;
  monthLabel: string = "";

  recordType: "HI1" | "HI2" = "HI1";

  loadingStatus: StatusBadgeConfig = {
    class: "status info",
    icon: "pi pi-sync pi-spin",
    text: "Loading",
  };

  ngOnInit(): void {
    this.setComponentProperties();
  }

  setComponentProperties() {
    this.monthLabel =
      this.month === "current"
        ? getContractualMonth({ offset: 0 }).monthShort
        : getContractualMonth({ offset: 1 }).monthShort;

    this.recordType = this.month === "current" ? "HI1" : "HI2";
  }
}
